import { includes } from '../../tools/utils';
export var ENDPOINTS = {
    alternate: {
        logs: 'logs',
        rum: 'rum',
        sessionReplay: 'session-replay',
    },
    classic: {
        logs: 'browser',
        rum: 'rum',
        // session-replay has no classic endpoint
        sessionReplay: undefined,
    },
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
export var ENDPOINTS_TYPES = Object.keys(ENDPOINTS['alternate']);
export var INTAKE_SITE_US = 'datadoghq.com';
var INTAKE_SITE_US3 = 'us3.datadoghq.com';
var INTAKE_SITE_GOV = 'ddog-gov.com';
var INTAKE_SITE_EU = 'datadoghq.eu';
var CLASSIC_ALLOWED_SITES = [INTAKE_SITE_US, INTAKE_SITE_EU];
var INTAKE_V1_ALLOWED_SITES = [INTAKE_SITE_US, INTAKE_SITE_US3, INTAKE_SITE_EU, INTAKE_SITE_GOV];
export function createEndpointBuilder(initConfiguration, buildEnv, isIntakeV2Enabled) {
    var sdkVersion = buildEnv.sdkVersion;
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US : _a, clientToken = initConfiguration.clientToken, env = initConfiguration.env, proxyHost = initConfiguration.proxyHost, proxyUrl = initConfiguration.proxyUrl, service = initConfiguration.service, version = initConfiguration.version, intakeApiVersion = initConfiguration.intakeApiVersion, useAlternateIntakeDomains = initConfiguration.useAlternateIntakeDomains;
    function build(endpointType, source) {
        var host = buildHost(endpointType);
        var path = buildPath(endpointType);
        var queryParameters = buildQueryParameters(endpointType, source);
        var endpoint = "https://" + host + path + "?" + queryParameters;
        if (proxyUrl) {
            return proxyUrl + "?ddforward=" + encodeURIComponent(endpoint);
        }
        else if (proxyHost) {
            return "https://" + proxyHost + path + "?ddhost=" + host + "&" + queryParameters;
        }
        return endpoint;
    }
    function buildIntakeUrl(endpointType) {
        var endpoint = build(endpointType);
        return endpoint.slice(0, endpoint.indexOf('?'));
    }
    function buildHost(endpointType) {
        if (shouldUseAlternateDomain(endpointType)) {
            var endpoint_1 = ENDPOINTS.alternate[endpointType];
            var domainParts = site.split('.');
            var extension = domainParts.pop();
            var suffix = domainParts.join('-') + "." + extension;
            return endpoint_1 + ".browser-intake-" + suffix;
        }
        var endpoint = ENDPOINTS.classic[endpointType];
        return endpoint + "-http-intake.logs." + site;
    }
    function buildPath(endpointType) {
        return shouldUseIntakeV2(endpointType) ? "/api/v2/" + INTAKE_TRACKS[endpointType] : "/v1/input/" + clientToken;
    }
    function buildQueryParameters(endpointType, source) {
        var tags = "sdk_version:" + sdkVersion +
            ("" + (env ? ",env:" + env : '')) +
            ("" + (service ? ",service:" + service : '')) +
            ("" + (version ? ",version:" + version : ''));
        var parameters = "ddsource=" + (source || 'browser') + "&ddtags=" + encodeURIComponent(tags);
        if (shouldUseIntakeV2(endpointType)) {
            parameters +=
                "&dd-api-key=" + clientToken + "&" +
                    ("dd-evp-origin-version=" + encodeURIComponent(sdkVersion) + "&") +
                    "dd-evp-origin=browser";
        }
        return parameters;
    }
    function shouldUseIntakeV2(endpointType) {
        return (!!isIntakeV2Enabled &&
            (intakeApiVersion === 2 || !includes(INTAKE_V1_ALLOWED_SITES, site) || endpointType === 'sessionReplay'));
    }
    function shouldUseAlternateDomain(endpointType) {
        return useAlternateIntakeDomains || !includes(CLASSIC_ALLOWED_SITES, site) || endpointType === 'sessionReplay';
    }
    return {
        build: build,
        buildIntakeUrl: buildIntakeUrl,
    };
}
//# sourceMappingURL=endpointBuilder.js.map